const statsData = [
  { value: '日更100+', label: '作品每日上新' },
  { value: '韩日国漫', label: '三大品类全覆盖' },
  { value: '永久免费', label: '全部漫画免费看' },
];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] flex items-center pt-[64px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100/50"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4 whitespace-nowrap">
              汗汗虫虫漫画 · 老用户入口
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
              虫虫漫画 · 海量韩漫日漫国漫
              <br className="hidden sm:block" />
              免费下拉式在线阅读
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6">
              虫虫漫画（曾用名汗汗虫虫漫画）是深受漫画爱好者喜爱的在线漫画平台。
              平台涵盖韩漫、日漫、国漫三大品类，每日稳定更新海量作品，
              提供流畅的下拉式阅读体验，让老用户通过汗汗漫画、虫虫汗汗等记忆点轻松回归。
              全场漫画无需注册即可免费阅读全集，随时随地畅享精彩内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {statsData.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                  <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{stat.value}</span>
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line"></i>
                立即探索热门漫画
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-800 rounded-lg font-semibold text-sm border border-background-300 hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-bar-chart-line"></i>
                查看人气排行
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[420px] lg:max-w-[480px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20warm-toned%20illustration%20of%20a%20digital%20manga%20reading%20experience%2C%20colorful%20comic%20book%20covers%20floating%20in%20a%20soft%20glow%2C%20smartphone%20and%20tablet%20displaying%20webtoon-style%20artwork%2C%20warm%20coral%20and%20amber%20accents%20on%20a%20light%20cream%20background%2C%20modern%20flat%20illustration%20style%20with%20subtle%20gradients%2C%20cozy%20reading%20atmosphere%2C%20artistic%20and%20inviting%20composition&width=960&height=720&seq=hero-comic-01&orientation=landscape"
                alt="虫虫漫画在线阅读体验 - 手机平板多端漫画阅读主视觉"
                className="w-full h-full object-cover"
                title="虫虫漫画 - 多端漫画在线阅读体验"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}